import React from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import { Link } from 'react-router-dom';


const Navbar = () => {

  // bg-slate-900








  const menuitems =
    <>




      <li className='text-gray-300 text-1xl  mx-1'>
        <a href="#about">  ABOUT </a></li>

      <li className='text-gray-300  text-1xl  mx-1'>
        <a href="#skill">  SKILLS </a></li>

      <li className='text-gray-300  text-1xl  mx-1'>
        <a href="#projects">  PROJECTS </a></li>


      <li className='text-gray-300  text-1xl  mx-1'>
        <a href="#contact">  CONTACT </a></li>





    </>








  return (
    <div className='nav-style sticky top-0 z-[50]  bg-[#020617]'>
      <div className="navbar flex justify-between">
        <div className="navbar-start ">
          <div className="dropdown">
            <label tabIndex="0" className=" lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <ul tabIndex="0" className="menu menu-compact  dropdown-content mt-3 ms-style p-2 shadow bg-slate-900  w-56">

              {menuitems}


            </ul>
          </div>
          <div className="normal-case  grid  text-2xl  text-black  ">


            <h1 className=' text-gray-300  '>ALONE_<span className='text-primary h1p'>MI</span></h1>

          </div>

        </div>
        <div className="navbar-center text-gray-300 mt-2 hidden lg:flex">
          <h1 className="menu menu-horizontal p-0">
            {menuitems}
          </h1>
        </div>
        <div>

        </div>


        <div className='navbar-end'>
          <label for="my-drawer-2" tabIndex="1" className="btn btn-ghost lg:hidden">

          </label>
          <h1 className='text-gray-300 mx-2'>RESUME</h1>

        </div>
        <div className="">
          <div className=" bg-white resume-btn-style text-primary font-bold  ring-offset-2">
            <a target="_blank" href="https://drive.google.com/file/d/1JO6Pim9MrqdeLhzHh7Q0eNKwr9nHSihw/view?usp=drive_link">
              <h1 className='p-2 text-2xl'> <AiOutlineDownload /></h1>
            </a>

          </div>
        </div>



        <li className='text-white font-bold text-1xl  mx-1'>
        </li>







      </div>
    </div>
  );
};

export default Navbar;